import RestService from '../services/rest';

async function getListVoltage(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/voltage/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getOptionsVoltage(search) {
  return RestService.getAuthenticated(
    `panel/voltage/options?search=${search}`,
  );
}

async function createVoltage(newVoltage) {
  return RestService.postAuthenticated(
    'panel/voltage/create', newVoltage,
  );
}

async function updateVoltage(updVoltage) {
  return RestService.putAuthenticated(
    'panel/voltage/update', updVoltage,
  );
}

export default {
  getOptionsVoltage,
  getListVoltage,
  createVoltage,
  updateVoltage,
};
